import { useTheme } from './ThemeContext';

/**
 * Alternador de tema — RNF-25.
 *
 * ================================================================
 * O ÍCONE MOSTRA O DESTINO, NÃO O ESTADO ATUAL
 * ================================================================
 *
 * No tema claro aparece a lua: o botão diz para onde ele leva. O contrário —
 * mostrar o sol porque está claro agora — descreve o que o usuário já está
 * vendo, e obriga a raciocinar antes de clicar.
 *
 * O rótulo acessível diz a mesma coisa por extenso, porque um ícone sozinho
 * não fala com leitor de tela (RNF-25) — e nem com quem nunca associou lua a
 * modo escuro.
 */
export function ThemeToggle() {
  const { theme, toggle } = useTheme();

  const indoParaEscuro = theme === 'claro';
  const rotulo = indoParaEscuro ? 'Mudar para o modo escuro' : 'Mudar para o modo claro';

  return (
    <button
      onClick={toggle}
      className="rounded-lg p-2 text-slate-500 transition hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800"
      title={rotulo}
      aria-label={rotulo}
    >
      <span aria-hidden="true">{indoParaEscuro ? '☾' : '☀'}</span>
    </button>
  );
}
